import { render, staticRenderFns } from "./VaIconSlower.vue?vue&type=template&id=248fd024"
import script from "./VaIconSlower.vue?vue&type=script&lang=js"
export * from "./VaIconSlower.vue?vue&type=script&lang=js"
import style0 from "./VaIconSlower.vue?vue&type=style&index=0&id=248fd024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports